import { Link } from "react-router-dom";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

interface SidebarMenuItemProps {
  icon: LucideIcon;
  label: string;
  path: string;
  isActive: boolean;
  badge?: string;
  featureKey?: string;
  onView?: (featureKey: string) => void;
}

export function SidebarMenuItem({ 
  icon: Icon, 
  label, 
  path, 
  isActive, 
  badge,
  featureKey,
  onView 
}: SidebarMenuItemProps) {
  const isMobile = useIsMobile();

  const handleClick = () => {
    if (featureKey && onView) {
      onView(featureKey);
    }
  };

  return (
    <Link
      to={path}
      onClick={handleClick}
      className={cn(
        "flex items-center gap-3 px-3 py-3 rounded-md text-gray-600 hover:bg-gray-100 transition-colors",
        isMobile ? "text-sm" : "text-xs",
        isActive && "font-medium bg-gray-100 text-gray-900"
      )}
    >
      <Icon className={cn("h-4 w-4", isMobile && "h-5 w-5")} />
      <span className="truncate flex-1">{label}</span>
      {badge && (
        <span className="bg-primary text-primary-foreground text-[10px] px-1.5 py-0.5 rounded font-medium">
          {badge}
        </span>
      )}
    </Link>
  );
}
